import types from './loginTypes'

const setLogout = () => ({ type: types.LOGIN_SET_LOGOUT })
const setIsAuthorized = (isAuthorized: boolean) => ({ type: types.LOGIN_SET_IS_AUTHORIZED, isAuthorized })
const setIsInputClick = (isInputClick: boolean) => ({ type: types.LOGIN_SET_IS_INPUT_CLICK, isInputClick })

const setLoginProfile = (login: string, lastName: string, firstName: string, secondName: string, accountCreateDate: string, position: string, avatar: string, phoneNumber: string, accessLevel: string) => ({ 
    type: types.LOGIN_SET_MY_PROFILE, login, lastName, firstName, secondName, accountCreateDate, position, avatar, phoneNumber, accessLevel 
})

const loginActions = {
    setLogout,
    setIsAuthorized,
    setIsInputClick,
    setLoginProfile,
}

export default loginActions